import { useContext } from "react";
import { CopyrightsContext } from "@/components/Copyrights";
export function useCopyrights() {
  return useContext(CopyrightsContext);
}
